
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'
import config from '@/config'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    innerWidth: null, // 当前窗口宽度
    coverType: config.BACKGROUND[Object.keys(config.BACKGROUND)[0]].key, // 壁纸种类
    backgroundShow: false, // 壁纸展示状态
    showBackgroundEffect: config.EFFECT[Object.keys(config.EFFECT)[0]].key, // 展示背景特效
    boxOpenState: false, // 盒子开启状态
    mobileOpenState: false, // 移动端开启状态
    mobileFuncState: false, // 移动端功能区开启状态
    setOpenState: false, // 设置页面开启状态
    backgroundState: 0, // 切换背景
    projectType: 'normal' // 项目类型
  },
  mutations: {
    setInnerWidth(state, value) {
      state.innerWidth = value
      if (value >= 720) {
        state.mobileOpenState = false
        state.mobileFuncState = false
      }
    },
    updateShowBackgroundEffect(state, value) {
      state.showBackgroundEffect = value
    },
    updateCoverType(state, value) {
      state.coverType = value
    },
    updateSetOpenState(state, value) {
      state.setOpenState = value
    },
    updateBoxOpenState(state, value) {
      state.boxOpenState = value
    },
    updateMobileFuncState(state, value) {
      state.mobileFuncState = value
    },
    updateMobileOpenState(state, value) {
      state.mobileOpenState = value
    },
    updateBackgroundShow(state, value) {
      state.backgroundShow = value
    },
    updateBackgroundState(state, value) {
      state.backgroundState = value
    },
    updateProjectType(state, value) {
      state.projectType = value
    }
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedstate({
      key: 'data',
      storage: window.localStorage,
      paths: ['coverType', 'showBackgroundEffect']
    })
  ]

})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js